import {
  FORGE_INFERENCE_GETTING_STARTED_PATH,
  FORGE_INFERENCE_PATH,
  FORGE_INFERENCE_PATHS,
} from '../../inference/paths';
import {createPreloadableLazyComponent} from '../../util/lazyImport';
import {type RouteData} from '../types';

export const FORGE_INFERENCE_ROUTES_DATA: RouteData[] = [
  {
    additionalProps: {
      allowIframes: false,
      datadogViewName: 'Inference',
    },
    exact: true,
    isPrivateRoute: false,
    path: FORGE_INFERENCE_PATHS,
    RouteComponent: createPreloadableLazyComponent(
      () => import('../../inference/InferenceApp')
    ).Component,
  },
  {
    exact: true,
    path: FORGE_INFERENCE_PATH,
    redirect: FORGE_INFERENCE_GETTING_STARTED_PATH,
  },
];
